/* NOÙMENO — motion. No dependencies. Everything degrades to the final state without JS. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  /* ---------- reveal on enter ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nm-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- statement: words light up with scroll ---------- */
  function initWords(root) {
    var blocks = (root || document).querySelectorAll('[data-nm-words]');
    blocks.forEach(function (block) {
      if (block.__nmWords) return;
      block.__nmWords = true;
      var words = block.querySelectorAll('.nm-word');
      if (!words.length) return;
      if (reduce || designMode) {
        words.forEach(function (w) { w.style.setProperty('--on', 1); });
        return;
      }
      var active = false;
      var ticking = false;

      function update() {
        ticking = false;
        var r = block.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        // 0 when the block's top is at 88% of the viewport, 1 when its bottom reaches 42%
        var start = vh * 0.88;
        var end = vh * 0.42;
        var p = (start - r.top) / (start - end + r.height * 0.55);
        p = Math.max(0, Math.min(1, p));
        var n = words.length;
        for (var i = 0; i < n; i++) {
          var local = Math.max(0, Math.min(1, p * (n + 3) - i));
          words[i].style.setProperty('--on', local.toFixed(3));
        }
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      var io = new IntersectionObserver(function (entries) {
        var on = entries[0].isIntersecting;
        if (on && !active) {
          active = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
          update();
        } else if (!on && active) {
          active = false;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          update();
        }
      }, { rootMargin: '10% 0px 10% 0px' });
      io.observe(block);
      update();
    });
  }

  /* ---------- count up ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-nm-count]');
    els.forEach(function (el) {
      if (el.__nmCount) return;
      el.__nmCount = true;
      var target = parseFloat(el.getAttribute('data-nm-count'));
      if (isNaN(target)) return;
      var decimals = (el.getAttribute('data-nm-count').split('.')[1] || '').length;
      if (reduce || designMode || !('IntersectionObserver' in window)) {
        el.textContent = target.toFixed(decimals);
        return;
      }
      el.textContent = (0).toFixed(decimals);
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null;
        var dur = 1800;
        function step(t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 4);
          el.textContent = (target * eased).toFixed(decimals);
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* ---------- horizontal rail: drag-free arrows ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-nm-rail]').forEach(function (rail) {
      if (rail.__nmRail) return;
      rail.__nmRail = true;
      var track = rail.querySelector('[data-nm-track]');
      var prev = rail.querySelector('[data-nm-prev]');
      var next = rail.querySelector('[data-nm-next]');
      if (!track) return;
      function step() {
        var card = track.querySelector('.nm-card');
        return card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  function boot(root) {
    initReveal(root);
    initWords(root);
    initCounters(root);
    initRails(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // theme editor: re-run when a section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
